import { Card, Typography } from "@mui/material";
import {
  CardInfo,
  CardTypesEnum,
  ItemLayoutsConfig,
} from "../../modules/dashboard/types";
import { useContext } from "react";
import { DashboardContext } from "../../modules/dashboard/context/DashboardContexProvider";
import {
  getUpdatedLayoutsAndCardId,
  getNewCardConfig,
} from "../themes/defaultLayout";
import CardBox from "./CardBox";

export type MiniCardProps = {
  type: CardTypesEnum;
  children?: React.ReactNode;
  subtitle: string;
  extraType?: CardTypesEnum;
};
export function MiniCard(props: MiniCardProps) {
  const {
    cardsConfig,
    setCardsConfig,
    layoutsConfig,
    setLayoutsConfig,
    canEditLayout,
    cardsDisplayableProps,
    getChildrenPropsByCardType,
  } = useContext(DashboardContext);

  function getUpdatedCardsInfo(
    type: CardTypesEnum,
    newLayoutsConfig?: ItemLayoutsConfig,
    newCardsConfig?: CardInfo[]
  ) {
    const { updatedLayouts, cardId } = getUpdatedLayoutsAndCardId(
      newLayoutsConfig ?? layoutsConfig,
      type
    );

    const newCardConfig = getNewCardConfig(
      type,
      cardId,
      cardsDisplayableProps,
      getChildrenPropsByCardType(type)
    );

    const updatedCardsConfig = newCardsConfig
      ? newCardsConfig.concat(newCardConfig)
      : cardsConfig.concat(newCardConfig);

    return { updatedLayouts, updatedCardsConfig };
  }

  function addCard() {
    const { updatedLayouts, updatedCardsConfig } = getUpdatedCardsInfo(
      props.type
    );
    if (props.extraType) {
      const {
        updatedLayouts: updatedLayouts2,
        updatedCardsConfig: updatedCardsConfig2,
      } = getUpdatedCardsInfo(
        props.extraType,
        updatedLayouts,
        updatedCardsConfig
      );
      setLayoutsConfig(updatedLayouts2);
      setCardsConfig(updatedCardsConfig2);
    } else {
      setLayoutsConfig(updatedLayouts);
      setCardsConfig(updatedCardsConfig);
    }
  }

  return (
    <CardBox
      sx={{
        height: "100px",
        width: "45%",
        cursor: "pointer",
        padding: "5px",
        flexDirection: "column",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "5px",
      }}
      onClick={() => {
        if (!canEditLayout) {
          return;
        }

        addCard();
      }}
    >
      {props.children && (
        <Card
          className="p-1 d-flex justify-content-center"
          sx={{ width: "fit-content", minWidth: "50px" }}
        >
          <Typography textAlign={"center"} fontSize={14}>
            {props.children}
          </Typography>
        </Card>
      )}
      <Typography textAlign={"center"} fontSize={12} className="py-2">
        <strong>{props.subtitle}</strong>
      </Typography>
    </CardBox>
  );
}
